// extracted by extract-css-chunks-webpack-plugin
module.exports = {"container":"container_3w1zn","container_fixed":"container_fixed_2nOZI"};